import React from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Container,
    Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h4" sx={{ textAlign: "center", mb: 3 }}>
                    Privacy Policy
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                    This privacy policy applies to the <strong>FFcorp Survey App</strong> (the "Application"), created by <strong>Nimap Infotech LLP</strong> as a Free service. This service is intended for use "AS IS".
                </Typography>

                {sections.map((section, index) => (
                    <Accordion key={index} sx={{ mb: 1 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">{section.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body1">{section.content}</Typography>
                            {section.list && (
                                <ul>
                                    {section.list.map((item, i) => (
                                        <li key={i}>
                                            <Typography variant="body2">{item}</Typography>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))}

                <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
                    If you have any questions, contact us at{" "}
                    <a href="mailto:kartikey@nimapinfotech.com">
                        kartikey@nimapinfotech.com
                    </a>
                </Typography>
            </Paper>
        </Container>
    );
};

const sections = [
    {
        title: "Information Collection and Use",
        content:
            "The Application collects certain information when you use it, such as:",
        list: [
            "Your device's IP address",
            "Pages you visit and the time spent on them",
            "Operating system of your mobile device",
        ],
    },
    {
        title: "Location Data",
        content:
            "The Application collects your location data to provide location-based services and improve performance.",
        list: [
            "Geolocation Services: Personalized content and recommendations.",
            "Analytics: Helps analyze user behavior and improve functionality.",
            "Third-Party Services: Periodic transmission of anonymized data to improve offerings.",
        ],
    },
    {
        title: "Third-Party Access",
        content:
            "The Application may share anonymized data with third-party services. Below are links to their Privacy Policies:",
        list: [
            <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">
                Google Play Services
            </a>,
            <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                Google Analytics for Firebase
            </a>,
            <a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">
                Firebase Crashlytics
            </a>,
        ],
    },
    {
        title: "Opt-Out Rights",
        content:
            "You can stop data collection by uninstalling the app via standard uninstall processes.",
    },
    {
        title: "Data Retention Policy",
        content:
            "The Application retains user data as long as the app is in use. If you want your data deleted, contact us.",
    },
    {
        title: "Children's Privacy",
        content:
            "The Application does not knowingly collect data from children under 13. If you believe your child has provided personal data, please contact us.",
    },
    {
        title: "Security",
        content:
            "We implement safeguards to protect your information, including physical, electronic, and procedural security measures.",
    },
    {
        title: "Changes",
        content:
            "This Privacy Policy may be updated from time to time. Continued use of the Application indicates acceptance of changes.",
    },
];

export default PrivacyPolicy;
